const ENDS_SENTENCE = /[.!?]$/;

// A capital followed by a small letter: "SIE", "AI" or the English "I" keep theirs.
const CAPITALISED_WORD = /^\p{Lu}\p{Ll}/u;

/**
 * The input's text with a dictation added: after what is there, so dictating twice continues the question. The
 * transcriber starts every clip with a capital, which mid-sentence is a stray one ("Hur bokför jag En faktura?"), so it
 * is taken down there. A name that starts the clip ("Spiris") is lowered too; that is the rarer case.
 */
export const appendDictation = (draft: string, text: string): string => {
    const kept = draft.trimEnd();
    if (kept === '') {
        return text;
    }
    const added =
        !ENDS_SENTENCE.test(kept) && CAPITALISED_WORD.test(text) ? text[0].toLocaleLowerCase() + text.slice(1) : text;
    return `${kept} ${added}`;
};
